import { SxProps } from "@mui/material";
import { parseDateLikeToLocalDateTime } from "util/dates";

export const gridSx: SxProps = {
  display: "grid",
  gridTemplateColumns: "repeat(12, 1fr)",
  columnGap: 2,
  rowGap: 2,
};

export const YES_NO_OPTIONS = [
  { value: true, label: "Yes" },
  { value: false, label: "No" },
];

// DateField leaves the calendar adornment's `position` unset unless
// `suggestionProps` is passed, which drops the open-calendar button (it renders
// like a bare text box). Pin the adornment to the end so the picker icon shows.
export const DATE_PICKER_PROPS = {
  slotProps: { inputAdornment: { position: "end" as const } },
};

// These sections store date-only values as UTC midnight. Normalize to the
// literal calendar day (via `parseDateLikeToLocalDateTime`) before handing the
// value to DateField, whose internal `DateTime.fromISO` would otherwise shift a
// `...T00:00:00Z` timestamp to the previous day in negative UTC-offset zones.
// This keeps the picker consistent with the frozen card's display.
export const toDatePickerValue = (value: string | null | undefined): string | null =>
  value ? (parseDateLikeToLocalDateTime(value)?.toISODate() ?? null) : null;

// §13 project types are split planned vs. unplanned by their enum prefix. The
// UI only offers the set matching the "planned?" answer, and the CE rule
// ("Project types must match the planned/unplanned selection") enforces it.
export const PLANNED_PROJECT_TYPE_PREFIX = "PLANNED_";
